import { Box, Divider, Stack, Text } from '@mantine/core';

import { AmendmentItems } from '@e-origin/shared';

import { renderField } from '../DeclarationViewCustoms';

interface AmendmentSectionViewProps {
  label: string;
  bucket: AmendmentItems;
}

export const AmendmentSectionView: React.FC<AmendmentSectionViewProps> = ({ label, bucket }) => (
  <Box ml="md">
    <Text fw={700} size="lg" mb="xs" mt="xs">
      {label}
    </Text>

    {bucket.additionalInformation.length > 0 && (
      <Stack gap="xs" mb="md">
        <Text fw={700} size="md">
          Additional information
        </Text>
        {bucket.additionalInformation.map((info, i) => (
          <Stack key={i} ml="md">
            <Divider />
            {renderField('Description:', info.description)}
            {renderField('Pointer:', info.pointer)}
          </Stack>
        ))}
      </Stack>
    )}

    {bucket.changes.length > 0 && (
      <Stack gap="xs">
        <Text fw={700} size="md">
          Changes
        </Text>
        {bucket.changes.map((change, i) => (
          <Stack key={i} ml="md">
            <Divider />
            <Text>Change reason: {change.reason}</Text>
            {renderField('Pointer:', change.pointer)}
          </Stack>
        ))}
      </Stack>
    )}
  </Box>
);
